import type { HabitFrequency } from './interfaces'

export interface HabitTemplate {
  emoji: string
  label: string
  name: string
  description: string
  category: string
  frequency_type: HabitFrequency
}

export const HABIT_TEMPLATES: HabitTemplate[] = [
  {
    emoji: '🏃',
    label: 'Running',
    name: 'Running',
    description: 'Morning run',
    category: 'Health',
    frequency_type: 'daily',
  },
  {
    emoji: '⚖️',
    label: 'Weight',
    name: 'Log Weight',
    description: 'Record body weight',
    category: 'Health',
    frequency_type: 'daily',
  },
  {
    emoji: '💧',
    label: 'Water',
    name: 'Drink Water',
    description: '8 glasses',
    category: 'Health',
    frequency_type: 'daily',
  },
  {
    emoji: '🧘',
    label: 'Mindfulness',
    name: 'Mindfulness',
    description: '10 min meditation',
    category: 'Personal',
    frequency_type: 'daily',
  },
  {
    emoji: '📚',
    label: 'Reading',
    name: 'Reading',
    description: '20 min reading',
    category: 'Learning',
    frequency_type: 'daily',
  },
  {
    emoji: '🔁',
    label: 'Other',
    name: '',
    description: '',
    category: 'General',
    frequency_type: 'daily',
  },
]
